import type { CommandHandler } from '../types';

export const addRelationsCommandHandler: CommandHandler = (command, context) => {
  if (!command.key) {
    return {
      success: false,
      error: 'Add Relations command is not configured.',
    };
  }

  if (!context.parentId && !context.entityId) {
    return {
      success: false,
      error: 'Save the parent record before adding relations.',
    };
  }

  if (!context.openRelationPicker) {
    return {
      success: false,
      error: 'Add Relations dialog is not available.',
    };
  }

  context.openRelationPicker(command);
  return { success: true };
};
